export default {
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasErrors() {
      return this.errors && this.errors.length > 0;
    },
  },
};



// WEBPACK FOOTER //
// ./mixins/Validation.js